// ai utility functions

import React, { useState } from 'react';
import styled from '@emotion/styled';

const _ = {
    filter:     require('lodash/filter'),
    find:       require('lodash/find'),
    forEach:    require('lodash/forEach'),
    map:        require('lodash/map'),
};

const ShortCourseConstants = require('../../../app/shared/ShortCourseConstants');

import ExpandableSpan from '../components/common/ExpandableSpan';
import AccessibleIcon from '../components/common/AccessibleIcon';


const VARIABLE_SOURCE = {
    BOILERPLATE: 'BOILERPLATE',
    CALCULATED: 'CALCULATED',
};

let EditButton = styled.button`
    display: inline-block;
    font-size: 1.2rem;
    background-color: white;
    color: black;
`;


function VariableEntry(props) {
    let { variableEntry, aiUtils, variableEntries, recurseCount } = props;
    const [activeForEditing, setActiveForEditing] = useState( aiUtils.activeEditEntry === variableEntry.id );
    
    let expandedText = variableEntry.value;
    let onClick = null;
    if (variableEntry.editable) {
        onClick=(e)=>{
            e.stopPropagation();
            if (aiUtils.activeEditEntry !== variableEntry.id) {
                aiUtils.activeEditEntry = variableEntry.id;
                setActiveForEditing(true);
            }
            else {
                aiUtils.activeEditEntry = null;
                setActiveForEditing(false);
            }
        };
    }                        
    let generateComplexContent = null;
    if (typeof expandedText !== 'string') {
        console.log("no value for variableEntry:",variableEntry); // FIXME
    }
    if (aiUtils.anyVariables(expandedText,variableEntries)) {
        generateComplexContent=()=>{
            if (recurseCount > 1) {
                return expandedText; // limit expansion
            }
            return aiUtils.makeVariableSubstitutionsForEditing({
                formatText:expandedText,
                variableEntries, 
                recurseCount: recurseCount+1
            });
        }
    }
    
    return (
        <span  className="variable-text">
            { variableEntry.editable ? 
            <EditButton title="edit" onClick={onClick}>
                <AccessibleIcon className="fa fa-pencil" label="edit"/> 
            </EditButton>
            : null }
            <ExpandableSpan 
                expandedText={variableEntry.value} 
                collapsedText={variableEntry.token} 
                expanded={!recurseCount} 
                activeForEditing={activeForEditing}
                generateComplexContent={generateComplexContent}
                onEdit={aiUtils.onChangeVariableEntry.bind(aiUtils,{variableEntry:variableEntry})}
            />
        </span>
    );
}

class AIUtils {
    constructor(props) {
        this.doc = props.doc;
        this.node = props.node;
        // flatten chatData and bot_options
        // flatten bot_options back into chatData
        let { bot_options, ...otherParams} = props.chatData;
        this.chatData = {...otherParams, ...bot_options };
        this.org_boilerplate = props.org_boilerplate;
        this.doc_boilerplate = props.doc.client_content.doc_boilerplate || {};

        this.onChangeBoilerplate=(bp_source,id,value)=>{
            // call parent function
            props.onChangeBoilerplate(bp_source,id,value);

            // then update our own data
            switch(bp_source) {
                case 'cb_boilerplate':
                {
                    if (!this.chatData.cb_boilerplate) {
                        this.chatData.cb_boilerplate = {};
                    }
                    console.log(`AIUtils onChangeBoilerplate setting cb_boilerplate ${id} to ${value}`); // FIXME: remove debug spam
                    this.chatData.cb_boilerplate[id] = value;
                    break;
                }
                case 'doc_boilerplate':
                {
                    console.log(`AIUtils onChangeBoilerplate setting doc_boilerplate ${id} to ${value}`); // FIXME: remove debug spam
                    this.doc_boilerplate[id] = value;
                    break;
                }
            }
        }
    }

    updateProps=(props)=>{
        this.doc = props.doc;
        this.node = props.node;
        let { bot_options, ...otherParams} = props.chatData;
        this.chatData = {...otherParams, ...bot_options };
        this.org_boilerplate = props.org_boilerplate;
        this.doc_boilerplate = props.doc.client_content.doc_boilerplate || {};
    }

    setOrgBoilerplate=(org_boilerplate)=>{
        this.org_boilerplate = org_boilerplate;
    }
    
    getNodeSubskills=()=>{
        const doc = this.doc;
        const node = this.node;
        return _.filter(doc.subskills,(ss)=>(!!ss.node_relations[node.node_id]));
    }
    
    getNumberOfSubskillsWord=(allNodeSubskills)=>{
        const subskills = this.getNodeSubskills();
        
        let numSubskills = 0;
        if (allNodeSubskills) {
            numSubskills = subskills.length;
        }
        else {
            let { subskill_relations } = this.chatData;
            _.forEach(subskill_relations,(dummy,hash)=>{
                let ss = _.find(subskills,{hash});
                if (ss) {
                    numSubskills++;
                }
            });
        }
        switch(numSubskills) {
            case 0: return "zero"; // degenerate case
            case 1: return "one";
            case 2: return "two";
            case 3: return "three";
            case 4: return "four";
            case 5: return "five";
            case 6: return "six";
            case 7: return "seven";
            case 8: return "eight";
            case 9: return "nine";
        }
        return String(numSubskills); // just return the digits (most likely we only have 3 or 4 subskills)
    } // getNumberOfSubskillsWord

    getSubskillNames=(allNodeSubskills)=>{
        const subskills = this.getNodeSubskills();
        let subskillNames = "";
        if (allNodeSubskills) {
            _.forEach(subskills,(ss)=>{
                if (subskillNames) {
                    subskillNames += ",";
                }
                subskillNames += ss.display_name;
            });
        }
        else {
            let { subskill_relations } = this.chatData;
            _.forEach(subskill_relations,(dummy,hash)=>{
                let ss = _.find(subskills,{hash});
                if (ss) {
                    if (subskillNames) {
                        subskillNames += ",";
                    }
                    subskillNames += ss.display_name;
                }
            });
        }
        return subskillNames;
    } // getSubskillNames
    
    getFocusSubskillName=()=>{
        const subskills = this.getNodeSubskills();
        let { subskill_relations } = this.chatData;
        let focusSubskillName = "";
        _.forEach(subskill_relations,(dummy,hash)=>{
            let ss = _.find(subskills,{hash});
            if (ss) {
                if (focusSubskillName) {
                    console.log("focusSubskillName is arbitrarily the first subskill"); // FIXME: add this as a bot option
                    return false; // bail now that we've logged the problem
                }
                focusSubskillName = ss.display_name;
            }
        });
        if (!focusSubskillName) {
            console.log("focusSubskillName is blank");
        }
        return focusSubskillName;
    } // getFocusSubskillName
    
    getSubskillResponseFormatRows=()=>{
        const subskills = this.getNodeSubskills();
        let { subskill_relations } = this.chatData;
        let rows = "";
        let variableEntry = {source: VARIABLE_SOURCE.BOILERPLATE, id: 'tutor_subskillResponseRowFormat'};
        let row_format = this.getVariableValue({variableEntry});
        _.forEach(subskill_relations,(dummy,hash)=>{
            let ss = _.find(subskills,{hash});
            if (ss) {
                if (rows) {
                    rows +=`\n`;
                }
                let value = row_format.split(`{subskill}`).join(ss.display_name);
                rows += value;
            }
        });
        return rows;
    }
    
    getSubskillFormatRows=()=>{
        const subskills = this.getNodeSubskills();
        let { subskill_relations } = this.chatData;
        let subskill_section = "";
        _.forEach(subskill_relations,(dummy,hash)=>{
            let ss = _.find(subskills,{hash});
            if (ss) {
                let value = `provide a progress value from 0 to 100 indicating the student's progress in ${ss.display_name}`;
                if (subskill_section) {
                    subskill_section += `,\n`;
                }
                subskill_section += `"${hash}": "${value}"`;
            }
        });
        if (subskill_section) {
            subskill_section += "\n";
        }
        return subskill_section;
    } // getSubskillFormatRows
    
    getCalculatedVariableValue=(props)=>{
        const { variableEntry } = props;
        switch(variableEntry.id) {
            case 'topicName':
                return this.chatData.topic;
            case 'botName':
                return this.chatData.botName;
            case 'numberOfSubskills':
                return this.getNumberOfSubskillsWord(true);
            case 'subskillNames':
                return this.getSubskillNames(true);
            case 'focusSubskillName':
                return this.getFocusSubskillName();
            case 'subskillResponseFormatRows':
                return this.getSubskillResponseFormatRows(true);
        }
    } // getCalculatedVariableValue

    getBoilerplateValue=(id)=>{
        const doc = this.doc;
        let cb_boilerplate = this.chatData.cb_boilerplate || {};
        if (typeof cb_boilerplate[id] === 'string') {
            return cb_boilerplate[id];
        }
        if (typeof this.doc_boilerplate[id] === 'string') {
            return this.doc_boilerplate[id];
        }
        if (typeof this.org_boilerplate[id] === 'string') {
            return this.org_boilerplate[id];
        }
        if (typeof ShortCourseConstants.AI_BOILERPLATE[id] === 'string') {
            return ShortCourseConstants.AI_BOILERPLATE[id];
        }
        return '';
    }
    
    getSourceDisplayName=(bp_source)=>{
        switch(bp_source) {
            case 'cb_boilerplate':
                return 'Specific to this content block';
            case 'doc_boilerplate':
                return 'Specific to this short course';
            case 'org_boilerplate':
                return 'Specific to this organization';
            case 'ai_boilerplate':
                return 'global default';
        }
    }
    
    getBoilerplateIdData=(id)=>{
        let data = {
            currentSource: '',
            currentValue: '',
            availableValues: {},
        };
        const doc = this.doc;
        let cb_boilerplate = this.chatData.cb_boilerplate || {};
        if (typeof cb_boilerplate[id] === 'string') {
            data.availableValues.cb_boilerplate = cb_boilerplate[id];
            data.currentSource = 'cb_boilerplate';
        }
        if (typeof this.doc_boilerplate[id] === 'string') {
            data.availableValues.doc_boilerplate = this.doc_boilerplate[id];
            if (!data.currentSource) {
                data.currentSource = 'doc_boilerplate';
            }
        }
        if (typeof this.org_boilerplate[id] === 'string') {
            data.availableValues.org_boilerplate = this.org_boilerplate[id];
            if (!data.currentSource) {
                data.currentSource = 'org_boilerplate';
            }
        }
        if (typeof ShortCourseConstants.AI_BOILERPLATE[id] === 'string') {
            data.availableValues.ai_boilerplate = ShortCourseConstants.AI_BOILERPLATE[id];
            if (!data.currentSource) {
                data.currentSource = 'ai_boilerplate';
            }
        }
        if (data.currentSource) {
            data.currentValue = data.availableValues[data.currentSource];
        }
        return data;
    }

    getVariableValue=(props)=>{
        const {variableEntry} = props;
        const doc = this.doc;
        if (variableEntry.source === VARIABLE_SOURCE.BOILERPLATE) {
            return this.getBoilerplateValue(variableEntry.id);
        }
        if (variableEntry.source === VARIABLE_SOURCE.CALCULATED) {
            return this.getCalculatedVariableValue(props);
        }
        if (props.defaultValue) {
            return props.defaultValue;
        }
        console.log("unknown variable source",variableEntry);
        return '';
    }

    // returns { formatText, variableEntries } 
    buildSystemFormatTextForTutor=(props)=>{
        //let {} = props;
        const doc = this.doc;
        if (!this.org_boilerplate) {
            console.log("missing org_boilerplate");
        }

        let cb_boilerplate = this.chatData.cb_boilerplate || {};
        let variableEntries = [];
        _.forEach(ShortCourseConstants.AI_BOILERPLATE, (value, id) => {
            variableEntries.push({id, source:VARIABLE_SOURCE.BOILERPLATE, editable: true});
        });
        
        // other variables
        variableEntries.push({
            id: 'botName', 
            source: VARIABLE_SOURCE.CALCULATED,
        });

        variableEntries.push({
            id: 'topicName', 
            source: VARIABLE_SOURCE.CALCULATED,
        });
        
        variableEntries.push({
            id: 'numberOfSubskills',
            source: VARIABLE_SOURCE.CALCULATED,
        });
        
        variableEntries.push({
            id: 'subskillNames',
            source: VARIABLE_SOURCE.CALCULATED,
        });
        
        variableEntries.push({
            id: 'focusSubskillName',
            source: VARIABLE_SOURCE.CALCULATED,
        });
        
        variableEntries.push({
            id: 'subskillResponseFormatRows',
            source: VARIABLE_SOURCE.CALCULATED,
        });
        
        let formatText = `\
{tutor_topLine}\n\
{tutor_courseSkillsLine}\n\
{tutor_focusSubskillParagraph}\n\
{tutor_rulesIntro}\n\
{tutor_keepFocusRule}\n\
{tutor_narrowFocusRule}\n\
{tutor_responseLengthRule}\n\
{tutor_notLastResponseRule}\n\
{tutor_userFocusRule}\n\
{tutor_examplesRule}\n\
{tutor_askRatherThanTellRule}\n\
{tutor_endConversationRule}\n\
{tutor_multipleExampleRepliesIntro}\n\
{tutor_offTopicExample}
{tutor_onTopicExample}
{tutor_responseFormat}`;

    return { formatText, variableEntries };

    } // buildSystemFormatTextForTutor

    makeVariableSubstitutions=(props)=>{
        let {formatText,variableEntries} = props;
        let finalText = formatText;
        let done;
        do {
            done = true;
            _.forEach(variableEntries,(variableEntry)=>{
                let token = `{${variableEntry.id}}`;
                if (finalText.indexOf(token) >= 0) {
                    let value = this.getVariableValue({variableEntry});
                    if (typeof value !== 'string') { 
                        // call again for debugging
                        console.log("no value for variableEntry:",variableEntry); // FIXME: remove debug code
                        value = this.getVariableValue({variableEntry}); // FIXME: remove debug code (place breakpoint here for debugging)
                        value = '';
                    }
                    if (value.indexOf('{') >= 0) {
                        //console.log(`will make another pass because of variable(s) in ${token}`);
                        done = false; // will need to make another pass
                    }
                    finalText = finalText.split(token).join(value); // replace all trick
                }
            });
        } while(!done);
        return finalText;
    } // makeVariableSubstitutions
    
    onChangeVariableEntry=(props,e)=>{
        let {variableEntry} = props;
        let value = e.target.value;
        this.onChangeBoilerplate('cb_boilerplate',variableEntry.id,value); // always start off making the change specific to the content block
    }

    anyVariables=(someText,variableEntries)=>{
        if (someText.indexOf('{') < 0) {
            return false;
        }
        let variableFound = false;
        _.forEach(variableEntries,(entry)=>{
            let token = `{${entry.id}}`;
            if (someText.indexOf(token) >= 0) {
                variableFound = true;
                return false;
            }
        });
        return variableFound;
    }

    makeVariableSubstitutionsForEditing=(props)=>{
        let { formatText, variableEntries, recurseCount } = props;
        if (!recurseCount) {
            recurseCount = 0;
        }
        let arr_elements = [{ processed:false, value: formatText }];
        _.forEach(variableEntries,(entry)=>{
            let new_arr = [];
            _.forEach(arr_elements,(elem)=>{
                if (elem.processed) {
                    new_arr.push(elem);
                }
                else {
                    let token = `{${entry.id}}`;
                    let value = this.getVariableValue({variableEntry:entry});
                    let unprocessedText = elem.value;
                    let parts = unprocessedText.split(token);
                    if (parts.length > 1) {
                        _.forEach(parts,(part,part_index)=>{
                            if (part) {
                                new_arr.push( {processed: false, value: part });
                            }
                            if (part_index < parts.length - 1) {
                                new_arr.push({
                                    processed: true, 
                                    id: entry.id,
                                    source: entry.source,
                                    editable: entry.editable,
                                    token, 
                                    value,
                                });
                                
                            }
                        });
                    }
                    else {
                        new_arr.push(elem);
                    }
                }
            }); // for arr_elements
            arr_elements = new_arr;
        });
        
        return (
            <div className={recurseCount ? "deeper-text" : "system-text"}>
                {_.map(arr_elements,(entry,i)=>{
                    if (entry.id) {
                        return (
                            <VariableEntry key={i} aiUtils={this} variableEntry={entry} variableEntries={variableEntries} recurseCount={recurseCount}/>
                        )
                    }
                    if (entry.expandable || entry.optional) {
                        // show this section as collapsed by default
                        return (
                            <ExpandableSpan key={i} expandedText={entry.value} collapsedText={entry.token}/>
                        )
                    }
                    return (
                        <span key={i} className="other-text">
                            {entry.value}
                        </span>
                    )
                })}
            </div>
        )
    } // makeVariableSubstitutionsForEditing
    
    buildSystemTextWithUIForTutor=()=>{
        let obj = this.buildSystemFormatTextForTutor();
        let ui = this.makeVariableSubstitutionsForEditing(obj);
        let { formatText, variableEntries } = obj;
        return { formatText, variableEntries, ui };
    }
    

} // class AIUtils 

module.exports = AIUtils;